import type { ConceptDef } from './types';
import { codesFor } from './programCode';
import { PROGRAM_CODES } from './programCodes';

/*
 * Auto-discover every concept defined under `games/`. Each file there exports one or
 * more ConceptDef constants. Add a file => it appears. Delete a file => it disappears.
 * No central list to maintain, zero cross-file imports between concept modules.
 */
const modules = import.meta.glob<Record<string, unknown>>('./games/*.ts', { eager: true });

function isConceptDef(v: unknown): v is ConceptDef {
  if (!v || typeof v !== 'object') return false;
  const o = v as Record<string, unknown>;
  return (
    typeof o.id === 'string' &&
    typeof o.label === 'string' &&
    typeof o.category === 'string' &&
    typeof o.description === 'string' &&
    typeof o.kind === 'string' &&
    !!o.config && typeof o.config === 'object'
  );
}

export const CONCEPTS: ConceptDef[] = Object.values(modules)
  .flatMap((mod) => Object.values(mod).flatMap((v) => (Array.isArray(v) ? v : [v])).filter(isConceptDef))
  .sort((a, b) => a.label.localeCompare(b.label));

export const CODES: Record<string, string> = codesFor(
  CONCEPTS.map((c) => ({ id: c.id, label: c.label, category: c.category, kind: c.kind })),
  PROGRAM_CODES,
);

export const codeOf = (id: string): string => CODES[id] ?? '';
